import { Pipe, PipeTransform } from '@angular/core';
import DimensionEnum = LabelDetailDto.DimensionEnum;
import { LabelDetailDto } from '@artemis-software/wr-api';

@Pipe({
  standalone: false,
  name: 'dimensionTranslation'
})
export class DimensionPipe implements PipeTransform {
  transform(value: DimensionEnum | undefined | null): string {
    switch (value) {
      case DimensionEnum.Temperature:
        return 'Temperatur';
      case DimensionEnum.Energy:
        return 'Energie';
      case DimensionEnum.Power:
        return 'Leistung';
      case DimensionEnum.Volume:
        return 'Volumen';
      case DimensionEnum.VolumeFlow:
        return 'Volumenstrom';
      case DimensionEnum.Pressure:
        return 'Druck';
      case DimensionEnum.Fraction:
        return 'Konzentration';
      case DimensionEnum.Voltage:
        return 'Spannung';
      case DimensionEnum.Current:
        return 'Stromstärke';
      case DimensionEnum.Frequency:
        return 'Frequenz';
      case DimensionEnum.None:
        return 'Keine Angabe';
      default:
        return 'Unbekannt';
    }
  }
}
